import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsXfceComponent } from './simple-icons-xfce.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsXfceComponent ],
    exports:      [ SimpleIconsXfceComponent ],
    bootstrap:    []
})
export class SimpleIconsXfceModule {}
